import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Cookies } from "react-cookie";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const getSocityImages= createAsyncThunk(
  "getSocityImages",
  async (id) => {
    try {
      const cookies = new Cookies();
      const token = cookies.get("token");
      const response = await AxiosInstance.get(
        `${API_KEY}/api/society/v2/media/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          "Content-Type": "application/json",
        }
      );
      return response;
    } catch (error) {
      if (error.response) {
        throw error.response.data.message;
      } else {
        throw error;
      }
    }
  }
);

const initialState = {
  isLoading: false,
  getSocityImagesData: null,
  isError: false,
  errorMessage: "",
};

const getSocityImagesSlice = createSlice({
  name: "getSocityImages",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSocityImages.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getSocityImages.fulfilled, (state, action) => {
      state.isLoading = false;
      state.getSocityImagesData = action.payload;
    });
    builder.addCase(getSocityImages.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default getSocityImagesSlice.reducer;
